export default __webpack_public_path__ + "static/media/illustration-recruit-4-m@3x.2fda2668.webp";